<template>
  <b-card
    class="mb-3"
    :class="comment.requested_version ? '' : 'text-muted'"
    :border-variant="border"
  >
    <div class="d-flex justify-content-between w-100 mb-2">
      <small>
        <router-link :to="{ hash: `#comment-${comment.id}` }"
          ><font-awesome-icon class="mr-1" :icon="['far', 'link']"
        /></router-link>
        Posted by {{ comment.user }}
        <span v-if="comment.parent_id">
          in reply to
          <router-link :to="{ hash: `#comment-${comment.parent_id}` }">
            {{ comment.parent_author }}
          </router-link>
        </span>
        <span v-if="comment.requested_version === false">
          on
          <router-link
            :to="{ name: 'EditVersion', params: { id: comment.version } }"
          >
            {{ comment.version_name }}
          </router-link>
        </span>
      </small>
      <small
        class="text-muted text-right info-tooltip"
        tabindex="0"
        v-b-tooltip.hover.focus
        :title="formattedDate"
        >{{ formatRelative(this.comment.created_on) }}</small
      >
    </div>

    <div v-html="parseMarkdown(comment.body)"></div>
    <div class="text-right">
      <b-button v-b-toggle="$id('reply-editor')" size="sm">Reply</b-button>
      &nbsp;
      <b-button @click.prevent="quote" size="sm">Quote</b-button>
    </div>
    <b-collapse
      :id="$id('reply-editor')"
      :accordion="accordionId"
      v-model="editorVisible"
    >
      <hr class="my-4" />
      <CommentEditor
        ref="editor"
        v-model="replyBody"
        @submit:comment="submitReply"
      />
    </b-collapse>
  </b-card>
</template>

<script>
import markdown from "@/mixins/markdown";
import dateFormat from "@/mixins/dateFormat";
import CommentEditor from "./CommentEditor.vue";

export default {
  components: { CommentEditor },
  name: "DeckSingleComment",
  data() {
    return {
      replyBody: "",
      editorVisible: false,
    };
  },
  mixins: [markdown, dateFormat],
  props: {
    comment: {
      type: Object,
      required: true,
    },
    accordionId: {
      type: String,
      required: false,
      default: "replyAccordion",
    },
    highlight: {
      default: null,
    },
  },
  computed: {
    formattedDate() {
      return this.formatDate(this.comment.created_on, "MMMM D, YYYY h:mma");
    },
    border() {
      if (this.comment.unread) return "warning";
      if (this.highlight) return this.highlight;
      return null;
    },
  },
  methods: {
    submitReply() {
      this.$emit("submit:reply", this.replyBody);
    },
    clear() {
      this.replyBody = "";
      this.editorVisible = false;
    },
    scrollTo() {
      const el = document.getElementById(`comment-${this.comment.id}`);
      el.scrollIntoView({ behavior: "smooth", block: "nearest" });
    },
    quote() {
      this.editorVisible = true;
      this.replyBody =
        this.comment.body
          .trimEnd()
          .replace(/^\s*$/gm, "\\")
          .replace(/^/gm, "> ") + "\n\n";
    },
  },
  watch: {
    highlight: {
      handler(value) {
        if (value) {
          this.$nextTick(this.scrollTo);
        }
      },
      immediate: true,
    },
  },
};
</script>
